import { render, staticRenderFns } from "./EditResearchAreaList.vue?vue&type=template&id=3c1ac258"
import script from "./EditResearchAreaList.vue?vue&type=script&lang=js"
export * from "./EditResearchAreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports